var _rect, _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D5162D",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20 10.583a.5.5 0 0 1 .428.241l9.583 15.834a.5.5 0 0 1-.428.759H10.417a.5.5 0 0 1-.428-.76l9.583-15.833a.5.5 0 0 1 .428-.24m8.696 15.834L20 12.049l-8.696 14.368zM20 16a.5.5 0 0 1 .5.5v4.583a.5.5 0 1 1-1 0V16.5a.5.5 0 0 1 .5-.5m.5 7.583a.5.5 0 1 0-1 0v.834a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  })));
});
const SvgError = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNENTE2MkQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCAxMC41ODMzQzIwLjE3NSAxMC41ODMzIDIwLjMzNzIgMTAuNjc0NyAyMC40Mjc4IDEwLjgyNDRMMzAuMDExMSAyNi42NTc3QzMwLjEwNDYgMjYuODEyMSAzMC4xMDc1IDI3LjAwNDkgMzAuMDE4OSAyNy4xNjIxQzI5LjkzMDMgMjcuMzE5MyAyOS43NjM4IDI3LjQxNjYgMjkuNTgzNCAyNy40MTY2SDEwLjQxNjdDMTAuMjM2MiAyNy40MTY2IDEwLjA2OTcgMjcuMzE5MyA5Ljk4MTExIDI3LjE2MjFDOS44OTI0OSAyNy4wMDQ5IDkuODk1NDggMjYuODEyMSA5Ljk4ODk0IDI2LjY1NzdMMTkuNTcyMyAxMC44MjQ0QzE5LjY2MjkgMTAuNjc0NyAxOS44MjUxIDEwLjU4MzMgMjAgMTAuNTgzM1pNMjguNjk2MyAyNi40MTY2TDIwIDEyLjA0ODlMMTEuMzAzOCAyNi40MTY2SDI4LjY5NjNaTTIwIDE1Ljk5OTlDMjAuMjc2MiAxNS45OTk5IDIwLjUgMTYuMjIzOCAyMC41IDE2LjQ5OTlWMjEuMDgzM0MyMC41IDIxLjM1OTQgMjAuMjc2MiAyMS41ODMzIDIwIDIxLjU4MzNDMTkuNzIzOSAyMS41ODMzIDE5LjUgMjEuMzU5NCAxOS41IDIxLjA4MzNWMTYuNDk5OUMxOS41IDE2LjIyMzggMTkuNzIzOSAxNS45OTk5IDIwIDE1Ljk5OTlaTTIwLjUgMjMuNTgzM0MyMC41IDIzLjMwNzEgMjAuMjc2MiAyMy4wODMzIDIwIDIzLjA4MzNDMTkuNzIzOSAyMy4wODMzIDE5LjUgMjMuMzA3MSAxOS41IDIzLjU4MzNWMjQuNDE2NkMxOS41IDI0LjY5MjcgMTkuNzIzOSAyNC45MTY2IDIwIDI0LjkxNjZDMjAuMjc2MiAyNC45MTY2IDIwLjUgMjQuNjkyNyAyMC41IDI0LjQxNjZWMjMuNTgzM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";